import { module } from 'modujs';
import { gsap } from '../gsap'

export default class ShoeParallax extends module {

    static get settings() {
        return {
            FRAME_ACTIVE_CLASS: 'is-active'
        }
    }

    constructor(m) {
        super(m);

        this.position = this.getData('position')

        this.$shoe = this.$('shoe')[0]
        this.$frames = this.$('frame')
        this.$leaveLeft = this.$('leave-left')[0]
        this.$leaveRight = this.$('leave-right')[0]
        this.sequenceLength = this.$frames.length

        if(this.position === 'center') {
            this.$title = this.$('title')[0]
            this.$desc = this.$('desc')[0]
            this.$rockLeft = this.$('rock-left')[0]
            this.$rockRight = this.$('rock-right')[0]
        }

    }

    init() {
        this.setTimeline()

        window.addEventListener('resizeEnd', this.onResize = () => this.resize())
    }

    setTimeline() {

        this.tl = false

        // Window width >= 1000px
        if (window.matchMedia('(min-width: 1000px)').matches) {

            if(this.position === 'left') {
                this.tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: this.el,
                        start: 'top bottom',
                        end: 'bottom center',
                        scrub: 0,
                        onEnter: () => {
                            gsap.to(this.$shoe, {
                                opacity: 1,
                                duration: .2
                            })
                        },
                        onLeaveBack: () => {
                            gsap.to(this.$shoe, {
                                opacity: 0,
                                duration: .2
                            })
                        }
                    },
                    defaults: {
                        ease: 'power2.out',
                        duration: 1
                    },
                })

                this.tl
                    // Content
                    .fromTo(this.$shoe,
                        {
                            yPercent: -10
                        },
                        {
                            yPercent: 0
                        },
                        0)
                    .fromTo(this.$leaveLeft,
                        {
                            yPercent: 100
                        },
                        {
                            yPercent: -70
                        },
                        0)
                    .fromTo(this.$leaveRight,
                        {
                            yPercent: 200
                        },
                        {
                            yPercent: 0
                        },
                        0)

            } else if (this.position === 'center') {

                this.tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: this.el,
                        start: 'top bottom',
                        end: 'bottom bottom',
                        // pin: true,
                        // anticipatePin: 1,
                        scrub: 1,
                        onEnter: () => {
                            gsap.to(this.$shoe, {
                                opacity: 1,
                                duration: .2
                            })
                        },
                        onLeaveBack: () => {
                            gsap.to(this.$shoe, {
                                opacity: 0,
                                duration: .2
                            })
                        }
                    },
                    defaults: {
                        ease: 'power2.out',
                        duration: 1
                    },
                })

                this.tl
                    // Content
                    .from(this.$title,
                        {
                            yPercent: 50
                        },
                        0)
                    .from(this.$desc,
                        {
                            yPercent: -50
                        },
                        0)

                    // Background
                    .fromTo(this.$shoe,
                        {
                            rotation: 30,
                            yPercent: -80,
                            scale: .8
                        },
                        {
                            rotation: 0,
                            yPercent: 0,
                            scale: 1
                        },
                        0)
                    .fromTo(this.$rockLeft,
                        {
                            rotation: 20,
                            xPercent: 80,
                            yPercent: -100,
                            scale: .8
                        },
                        {
                            rotation: 0,
                            xPercent: 0,
                            yPercent: 0,
                            scale: 1
                        },
                        0)
                    .fromTo(this.$leaveLeft,
                        {
                            rotation: 10,
                            xPercent: -300,
                            y: '-20vw'
                        },
                        {
                            rotation: 0,
                            xPercent: 0,
                            y: 0
                        },
                        0)
                    .fromTo(this.$rockRight,
                        {
                            rotation: -20,
                            xPercent: -80,
                            yPercent: -100,
                            scale: .8
                        },
                        {
                            rotation: 0,
                            xPercent: 0,
                            yPercent: 0,
                            scale: 1
                        },
                        0)
                    .fromTo(this.$leaveRight,
                        {
                            rotation: -40,
                            xPercent: 240,
                            y: '-20vw'
                        },
                        {
                            rotation: 0,
                            xPercent: 0,
                            y: 0
                        },
                        0)
            }

        // Window width < 1000px
        } else {

            this.tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: 'top center',
                    end: 'bottom center',
                    scrub: 0,
                    onEnter: () => {
                        gsap.to(this.$shoe, {
                            opacity: 1,
                            duration: .2
                        })
                    },
                    onLeaveBack: () => {
                        gsap.to(this.$shoe, {
                            opacity: 0,
                            duration: .2
                        })
                    }
                },
                defaults: {
                    ease: 'power2.out',
                    duration: 1
                },
            })

            this.tl
                // Content
                .fromTo(this.$shoe,
                    {
                        yPercent: -10
                    },
                    {
                        yPercent: 0
                    },
                    0)
                .fromTo(this.$leaveLeft,
                    {
                        yPercent: 100
                    },
                    {
                        yPercent: -70
                    },
                    0)
                .fromTo(this.$leaveRight,
                    {
                        yPercent: 200
                    },
                    {
                        yPercent: 0
                    },
                    0)
        }

        // if(this.position === 'left') {

        //     gsap.set(this.$shoe, {
        //         opacity: 0
        //     })

        //     // Window width >= 1000px
        //     if(window.matchMedia('(min-width: 1000px)').matches) {

        //         this.tl = gsap.timeline({
        //             scrollTrigger: {
        //                 trigger: this.el,
        //                 start: 'top bottom',
        //                 end: 'bottom center',
        //                 scrub: 0,
        //                 onEnter: () => {
        //                     gsap.to(this.$shoe, {
        //                         opacity: 1,
        //                         duration: .2
        //                     })
        //                 },
        //                 onLeaveBack: () => {
        //                     gsap.to(this.$shoe, {
        //                         opacity: 0,
        //                         duration: .2
        //                     })
        //                 }
        //             },
        //             defaults: {
        //                 ease: 'power2.out',
        //                 duration: 1
        //             },
        //         })

        //         this.tl
        //             // Content
        //             .fromTo(this.$shoe,
        //                 {
        //                     yPercent: -10
        //                 },
        //                 {
        //                     yPercent: 0
        //                 },
        //             0)
        //             .fromTo(this.$leaveLeft,
        //                 {
        //                     yPercent: 100
        //                 },
        //                 {
        //                     yPercent: -70
        //                 },
        //             0)
        //             .fromTo(this.$leaveRight,
        //                 {
        //                     yPercent: 200
        //                 },
        //                 {
        //                     yPercent: 0
        //                 },
        //             0)

        //     // Window width < 1000px
        //     } else {

        //         this.tl = gsap.timeline({
        //             scrollTrigger: {
        //                 trigger: this.el,
        //                 start: 'top center',
        //                 end: 'bottom center',
        //                 scrub: 0,
        //                 onEnter: () => {
        //                     gsap.to(this.$shoe, {
        //                         opacity: 1,
        //                         duration: .2
        //                     })
        //                 },
        //                 onLeaveBack: () => {
        //                     gsap.to(this.$shoe, {
        //                         opacity: 0,
        //                         duration: .2
        //                     })
        //                 }
        //             },
        //             defaults: {
        //                 ease: 'power2.out',
        //                 duration: 1
        //             },
        //         })

        //         this.tl
        //             // Content
        //             .fromTo(this.$shoe,
        //                 {
        //                     yPercent: -10
        //                 },
        //                 {
        //                     yPercent: 0
        //                 },
        //             0)
        //             .fromTo(this.$leaveLeft,
        //                 {
        //                     yPercent: 100
        //                 },
        //                 {
        //                     yPercent: -70
        //                 },
        //             0)
        //             .fromTo(this.$leaveRight,
        //                 {
        //                     yPercent: 200
        //                 },
        //                 {
        //                     yPercent: 0
        //                 },
        //             0)
        //     }

        // } else if(this.position === 'center' && window.matchMedia('(min-width: 1000px)').matches) {

        //     gsap.set(this.$shoe, {
        //         opacity: 0
        //     })

        //     this.tl = gsap.timeline({
        //         scrollTrigger: {
        //             trigger: this.el,
        //             start: 'top bottom',
        //             end: 'bottom bottom',
        //             // pin: true,
        //             // anticipatePin: 1,
        //             scrub: 1,
        //             onEnter: () => {
        //                 gsap.to(this.$shoe, {
        //                     opacity: 1,
        //                     duration: .2
        //                 })
        //             },
        //             onLeaveBack: () => {
        //                 gsap.to(this.$shoe, {
        //                     opacity: 0,
        //                     duration: .2
        //                 })
        //             }
        //         },
        //         defaults: {
        //             ease: 'power2.out',
        //             duration: 1
        //         },
        //     })

        //     this.tl
        //         // Content
        //         .from(this.$title,
        //             {
        //                 yPercent: 50
        //             },
        //         0)
        //         .from(this.$desc,
        //             {
        //                 yPercent: -50
        //             },
        //         0)

        //         // Background
        //         .fromTo(this.$shoe,
        //             {
        //                 rotation: 30,
        //                 yPercent: -80,
        //                 scale: .8
        //             },
        //             {
        //                 rotation: 0,
        //                 yPercent: 0,
        //                 scale: 1
        //             },
        //         0)
        //         .fromTo(this.$rockLeft,
        //             {
        //                 rotation: 20,
        //                 xPercent: 80,
        //                 yPercent: -100,
        //                 scale: .8
        //             },
        //             {
        //                 rotation: 0,
        //                 xPercent: 0,
        //                 yPercent: 0,
        //                 scale: 1
        //             },
        //         0)
        //         .fromTo(this.$leaveLeft,
        //             {
        //                 rotation: 10,
        //                 xPercent: -300,
        //                 y: '-20vw'
        //             },
        //             {
        //                 rotation: 0,
        //                 xPercent: 0,
        //                 y: 0
        //             },
        //         0)
        //         .fromTo(this.$rockRight,
        //             {
        //                 rotation: -20,
        //                 xPercent: -80,
        //                 yPercent: -100,
        //                 scale: .8
        //             },
        //             {
        //                 rotation: 0,
        //                 xPercent: 0,
        //                 yPercent: 0,
        //                 scale: 1
        //             },
        //         0)
        //         .fromTo(this.$leaveRight,
        //             {
        //                 rotation: -40,
        //                 xPercent: 240,
        //                 y: '-20vw'
        //             },
        //             {
        //                 rotation: 0,
        //                 xPercent: 0,
        //                 y: 0
        //             },
        //         0)
        // }

        this.setSequence()
    }

    setSequence() {
        if(this.sequenceLength === 0 || !this.tl) {
            return
        }

        let oldVal = 0
        const sequenceProxy = {
            value: 0
        }

        this.tl
            // Content
            .fromTo(sequenceProxy,
                {
                    value: 0
                },
                {
                    value: this.sequenceLength - 1,
                    ease: 'none',
                    onUpdate: () => {
                        const val = Math.floor(sequenceProxy.value)

                        if(val !== oldVal) {
                            this.$frames[val].classList.add(ShoeParallax.settings.FRAME_ACTIVE_CLASS)
                            this.$frames[oldVal].classList.remove(ShoeParallax.settings.FRAME_ACTIVE_CLASS)
                            oldVal = val
                        }
                    }
                },
            0)
    }

    resize() {

        if(this.tl) {
            this.tl.scrollTrigger.kill(true)
            this.tl.kill(true)

            const $elements = [this.$shoe, this.$leaveLeft, this.$leaveRight]

            if(this.position === 'center') {
                $elements.push(this.$title, this.$desc, this.$rockLeft, this.$rockRight)
            }

            gsap.set($elements, {
                clearProps: 'all'
            })
        }

        this.setTimeline()
    }

    destroy() {

        if(this.tl) {
            this.tl.kill()
        }

        window.removeEventListener('resizeEnd', this.onResize)
    }
}
